<div class="{{ 'size--' + size }}">
	<ng-template #indicatorTemplate
		><i nz-icon nzType="loading"></i
	></ng-template>
	<nz-spin nzSimple [nzIndicator]="indicatorTemplate"></nz-spin>
</div>
